import {action, observable, toJS} from 'mobx';

class ReportFormStore {


  @observable data = observable.map([]);
  @observable error = {};
  @observable errors = [];

  constructor() {

  }

  @action
  reset=()=>{
    this.data.clear();
  }

  @action
  onFieldChange=(name,value)=>{
    this.data.set(name,value);
  };

  @action
  setField=(name,value)=>{
    this.data.set(name,value);
  };

  getField = (name,defaultValue) => {
    if(!this.data.has(name)) {
      this.data.set(name,defaultValue);
    }
    return toJS(this.data.get(name));
  }

  addError = (error) =>{
    this.errors = [error];
  }

  getErrors = () =>{
    return this.errors;
  }

  getData = () =>{
      return toJS(this.data);
  }
}

export default ReportFormStore;
